<script>
  // @ts-check
  import { createEventDispatcher } from "svelte";

  // eslint-disable-next-line
  import * as Types from "./globalNavigationTypes";
  import { tick } from "svelte";
  import Constants from "./globalNavigationConstants";
  import { getTheme } from "../../utilities/themes";

  /** @type {import('../../utilities/themes').ThemeName} */
  export let theme;

  /** @type {Types.Link} */
  export let link;

  /** @type {string} label of active section */
  export let displayedMobileSection = undefined;

  const dispatch = createEventDispatcher();

  /** @type {HTMLElement | undefined}  */
  let labelLinkElement;

  const currentTheme = getTheme(theme);
  const linkLabel = link?.label.replace(/\s/g, "");
</script>

<svelte:element
  this="button"
  bind:this={labelLinkElement}
  id={Constants.primaryLinkPrefixMobile + linkLabel}
  aria-controls={Constants.secondarySectionPrefixMobile + linkLabel}
  aria-expanded={link?.label === displayedMobileSection}
  on:click={async () => {
    dispatch("mobileLabelClicked", {
      displayedMobileSection: link?.label
    });
    // When svelte:element changes element it loses focus
    // So we use tick to compensate for that
    await tick();
    labelLinkElement?.focus();
  }}
  class="
    heading-md relative flex items-center
    transition
    {currentTheme.focusOutlineColor} 
    focus-visible:outline-dashed focus-visible:outline-offset-2
    {currentTheme.focusOutlineColor} {currentTheme.focusTextColor}
    mt-4
    items-center
    justify-between {link?.label === 'Democracy Forum'
    ? `animate-text bg-dark-blue-animated-text bg-clip-text text-transparent`
    : ''}
  "
>
  {link?.label}
</svelte:element>
